import { apiCallWithAuthWithReturn, handleResponseErrorData, handleResponseErrorDataReturn } from "../../clinic/utils/commonUtils";

const API_URL = process.env.REACT_APP_API_URL;

export const verifyPatientOTP = async (phoneNumber, otp) => {
  try {
    const data=JSON.stringify({phoneNumber, otp});
    const url= `${API_URL}/auth/verifyPatientOTP`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{},null);
  } catch (error) {
      return handleResponseErrorDataReturn(error, null);
  }
};

export const addPatient = async (userId, firstName, lastName, age, date_of_birth,gender) => {
  try {
    const data=JSON.stringify({userId, firstName, lastName, age, date_of_birth,gender });
    const url= `${API_URL}/auth/addPatient`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const addRelatedPatient = async (
  relatedPatientId,
  firstName,
  lastName,
  age,
  date_of_birth,
  gender,
 contactNumber,
  relationType
) => {
  try {
    const data=JSON.stringify({relatedPatientId,
      firstName,
      lastName,
      age,
      date_of_birth,
      gender,
     contactNumber,
      relationType, });
    const url= `${API_URL}/auth/addRelatedPatient`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const createAppointment = async (patientId, doctorId, clinicId) => {
  try {
    const data=JSON.stringify({patientId, doctorId, clinicId});
    const url= `${API_URL}/appointments/createAppointment`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const fetchPatientAndRelatives = async (userId) => {
  try {
    const data=JSON.stringify({userId});
    const url= `${API_URL}/auth/getPatientAndRelatives`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const getPeopleAheadCount = async (patientId, doctorId, clinicId) => {
  try {
    const data=JSON.stringify({patientId, doctorId, clinicId});
    const url= `${API_URL}/appointments/getPeopleAheadCount`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const serviceGetClinicBasicDetails = async (clinicId) => {
  try {
    const data=JSON.stringify({clinicId: clinicId});
    const url= `${API_URL}/init/checkProfile/clinicBasicDetails`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const serviceGetUserBasicInformation = async (userId) => {
  try {
    const data=JSON.stringify({user_id: userId});
    const url= `${API_URL}/init/checkProfile/userBasicInformation`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const serviceGetUserContactInfo = async (userId) => {
  try {
    const data=JSON.stringify({user_id: userId});
    const url= `${API_URL}/init/checkProfile/contactInfo`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const serviceGetUserAddress = async (userId,clinicId,callType) => {
  try {
    const data=JSON.stringify({user_id: userId,clinic_id:clinicId});
    const url= `${API_URL}/auth/getPatientAddress`;
    return await apiCallWithAuthWithReturn(url,'POST',data,callType=='patient'?{token_type:'pat'}:{},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const serviceUpdateUser = async (params) => {
  const {callType} = params;
  try {
    const data=JSON.stringify(params);
    const url= `${API_URL}/auth/updateUser`;
    return await apiCallWithAuthWithReturn(url,'POST',data,callType=='patient'?{token_type:'pat'}:{},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const serviceUpdateUserAddress = async (params) => {
  try {
    const data=JSON.stringify(params);
    const url= `${API_URL}/auth/updatePatientAddress`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const serviceUpdateUserContact = async (params) => {
  const {callType} = params;
  try {
    const data=JSON.stringify(params);
    const url= `${API_URL}/auth/updateUserContact`;
    return await apiCallWithAuthWithReturn(url,'POST',data,callType=='patient'?{token_type:'pat'}:{},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const serviceUpdatePrimaryPhoneNumberRequest = async (params) => {
  try {
    const data=JSON.stringify(params);
    const url= `${process.env.REACT_APP_API_URL}/auth/updatePrimaryPhoneNumberRequest`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const serviceVerifyOtpAndUpdate = async (params) => {
  try {
    const data=JSON.stringify(params);
    const url= `${process.env.REACT_APP_API_URL}/auth/updatePrimaryEmail/verifyOtpAndUpdate`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};

export const serviceUpdatePrimaryPhoneNumberAndVerifyOtp = async (params) => {
  try {
    const data=JSON.stringify(params);
    const url= `${process.env.REACT_APP_API_URL}/auth/updatePrimaryPhoneNumber/verifyOtpAndUpdate`;
    return await apiCallWithAuthWithReturn(url,'POST',data,{token_type:'pat'},null);
} catch (error) {
    return handleResponseErrorData(error, null);
} 
};